<div class="cc-backdrop" *ngIf="isOpen" (click)="close()">
  <div class="cc-modal" (click)="$event.stopPropagation()">

    <!-- ── Header ─────────────────────────────────────────────────── -->
    <div class="cc-header">
      <div class="cc-header__left">
        <div class="cc-header__icon-wrap">
          <img [src]="headerIconSrc" alt="CC" class="cc-header__icon" />
        </div>
        <h2 class="cc-header__title">{{ headerTitle }}</h2>
      </div>
      <div class="cc-header__actions">
        <button class="cc-header__btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        </button>
        <button class="cc-header__btn cc-header__btn--close" (click)="close()">✕</button>
      </div>
    </div>

    <!-- ── Body ───────────────────────────────────────────────────── -->
    <div class="cc-body">

      <!-- Left Column -->
      <div class="cc-col cc-col--left">

        <!-- AI Text Box -->
        <div class="cc-ai-box">
          <p class="cc-ai-box__text">{{ aiText }}</p>
        </div>

        <!-- Critical Controls Mini Card -->
        <div class="cc-mini-card">
          <div class="cc-mini-card__header">
            <img [src]="ccCard.iconSrc" [alt]="ccCard.iconAlt" class="cc-mini-card__icon" />
            <div>
              <p class="cc-mini-card__title">{{ ccCard.title }}</p>
              <p class="cc-mini-card__sub">{{ ccCard.subtitle }}</p>
            </div>
          </div>
          <div class="cc-mini-card__chart" [style.background]="chartBg(ccScore)">
            <div #ccChartEl class="cc-apex-sparkline"></div>
            <span class="cc-mini-card__score">{{ ccScore }}%</span>
          </div>

          <!-- Top 3 / Bottom 3 -->
          <div class="cc-tb3">
            <div class="cc-tb3__col">
              <div class="cc-tb3__header cc-tb3__header--top">
                <img src="assets/performance/thumbs-up.svg" alt="" class="cc-tb3__thumb" />
                Top 3
              </div>
              <div *ngFor="let p of ccTop3" class="cc-tb3__row">
                <span class="cc-tb3__name">{{ p.name }}</span>
                <span class="cc-tb3__score cc-tb3__score--green">{{ p.score }}</span>
              </div>
            </div>
            <div class="cc-tb3__divider"></div>
            <div class="cc-tb3__col">
              <div class="cc-tb3__header cc-tb3__header--bottom">
                <img src="assets/performance/thumbs-down.svg" alt="" class="cc-tb3__thumb" />
                Bottom 3
              </div>
              <div *ngFor="let p of ccBottom3" class="cc-tb3__row">
                <span class="cc-tb3__name">{{ p.name }}</span>
                <span class="cc-tb3__score cc-tb3__score--red">{{ p.score }}</span>
              </div>
            </div>
          </div>
          <p class="cc-mini-card__verification">{{ ccVerification }}</p>
        </div>

      </div>

      <!-- Right Column -->
      <div class="cc-col cc-col--right">

        <!-- CRE Mini Card -->
        <div class="cc-mini-card">
          <div class="cc-mini-card__header">
            <img [src]="creCard.iconSrc" [alt]="creCard.iconAlt" class="cc-mini-card__icon" />
            <div>
              <p class="cc-mini-card__title">{{ creCard.title }}</p>
              <p class="cc-mini-card__sub">{{ creCard.subtitle }}</p>
            </div>
          </div>
          <div class="cc-mini-card__chart" [style.background]="chartBg(creScore)">
            <div #creChartEl class="cc-apex-sparkline"></div>
            <span class="cc-mini-card__score">{{ creScore }}%</span>
          </div>

          <!-- Progress bar -->
          <div class="cc-progress-wrap">
            <div class="cc-progress-labels">
              <span class="cc-progress-labels__val">{{ creProgress.closed }}%</span>
              <span class="cc-progress-labels__val cc-progress-labels__val--mid">{{ creProgress.open }}%</span>
              <span class="cc-progress-labels__val cc-progress-labels__val--right">{{ creProgress.overdue }}%</span>
            </div>
            <div class="cc-progress-bar">
              <div class="cc-progress-bar__seg cc-progress-bar__seg--green" [style.width.%]="creProgress.closed"></div>
              <div class="cc-progress-bar__seg cc-progress-bar__seg--yellow" [style.width.%]="creProgress.open"></div>
              <div class="cc-progress-bar__seg cc-progress-bar__seg--red" [style.width.%]="creProgress.overdue"></div>
            </div>
            <div class="cc-progress-legend">
              <ng-container *ngFor="let leg of progressLegend">
                <span class="cc-progress-legend__dot" [ngClass]="leg.colorClass"></span> {{ leg.label }}
              </ng-container>
            </div>
          </div>

          <!-- Stats row -->
          <div class="cc-stats-row">
            <div *ngFor="let s of creStats" class="cc-stats-row__item">
              <span class="cc-stats-row__value">{{ s.value }}</span>
              <span class="cc-stats-row__label">{{ s.label }}</span>
            </div>
          </div>

          <!-- Overdue CRE Findings -->
          <div class="cc-overdue">
            <p class="cc-overdue__title">{{ overdueTitle }}<br /><span>{{ overdueSubtitle }}</span></p>
            <div class="cc-overdue__scroll">
              <table class="cc-overdue__table">
                <colgroup>
                  <col class="col-date" />
                  <col class="col-location" />
                  <col class="col-level" />
                </colgroup>
                <thead>
                  <tr>
                    <th *ngFor="let col of overdueColumns">
                      {{ col }} <span class="cc-overdue__search"><img [src]="searchIconSrc" alt="search" /></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of overdueFindings">
                    <td [style.color]="row.dateColor" class="cc-overdue__date">{{ row.date }}</td>
                    <td>{{ row.location }}</td>
                    <td class="cc-overdue__level">
                      {{ row.level }}
                      <button class="cc-overdue__view-btn" (click)="openFindingDetails(row); $event.stopPropagation()">{{ "VIEW" | translate }}</button>
                    </td>
                  </tr>
                  <tr *ngIf="overdueFindings.length === 0">
                    <td colspan="3" class="cc-overdue__empty">No overdue CRE findings</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
